import { setupConnectJs } from '@atlassian/jira-connect/src/index.tsx';

const addDNSPrefetchLink = (url: any) => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const linkElem = document.createElement('link');
	linkElem.rel = 'dns-prefetch';
	linkElem.href = url;

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	document.getElementsByTagName('head')[0].appendChild(linkElem);
};

// `setupConnectJs` here is used to load ACJS globally,
// so that other Jira FE parts can use ACJS without `setupConnectJs`.
// This is not ideal because it's a bad practice to make other parts to think ACJS implicitly exists.
setupConnectJs();

fetch('/rest/atlassian-connect/latest/addons-baseurl')
	.then((response) => (response.ok ? response.json() : {}))
	// @ts-expect-error - TS2339 - Property 'addonBaseUrls' does not exist on type '{}'. | TS2339 - Property 'addonBaseUrls' does not exist on type '{}'.
	.then((json) => json.addonBaseUrls && json.addonBaseUrls.forEach(addDNSPrefetchLink))
	.catch(() => {});

// this line is to fix the error in Type Checking build `TS2306: ...'src/entry/connect-modules.tsx' is not a module.`
// eslint-disable-next-line @typescript-eslint/no-useless-empty-export
export {};
